<template>
  <div class="homePage">
    <div class="fiex" :style="{ top: menuTop + 'px' }">
      <Navigation :active="8"></Navigation>
    </div>
    <div class="right">
      <div class="screen-box2">
        <div class="left"></div>
      </div>
      <div class="list-box" ref="scrollContainer" @scroll="handleScroll">
        <div class="list-item" v-for="(item, index) in tableData2" :key="index">
          <div class="line-box">
            <div class="title">{{ item.description }}</div>
            <div class="content color2">
              <div class="participationStatus" v-if="item.typeId === 1">
                <span style="background-color: #67c23a"></span>
{{ $t("module.credit.title53") }}
              </div>
              <div class="participationStatus" v-if="item.typeId === 2">
                <span style="background-color: #f56c6c"></span>
                {{ $t("module.credit.title54") }}
              </div>
            </div>
          </div>
          <div class="line-box">
            <div class="title color1">{{ item.dateline | dateFrom }}</div>
            <div class="content color3">
              {{ item.typeId === 1 ? "+" : "-" }}{{ item.quantity }}
            </div>
          </div>
        </div>
        <div class="flag" v-if="!flag && tableData2.length !== 0">
          {{ $t("module.credit.title55") }}
        </div>
        <div class="flag" v-if="flag && tableData2.length !== 0">
          {{ $t("module.credit.title56") }}
        </div>

        <el-empty
          v-if="tableData2.length === 0"
          :description="$t('module.credit.title57')"
        ></el-empty>
      </div>
      <div class="table-box">
        <div class="table-name">
          <div>{{ $t("module.credit.title58") }}</div>

          <div class="goback" @click="goback">{{ $t("module.credit.title59") }}</div>
        </div>
        <el-table :data="tableData" height="820" border style="width: 100%">
          <el-table-column prop="number" :label="$t('module.credit.title60')" width="180">
            <template slot-scope="scope">
              {{ scope.row.dateline | dateFrom }}
            </template>
          </el-table-column>
          <el-table-column prop="quantity" :label="$t('module.credit.title61')" width="150">
          </el-table-column>

          <el-table-column prop="participationStatus" :label="$t('module.credit.title62')" width="150">
            <template slot-scope="scope">
              <div class="participationStatus" v-if="scope.row.typeId === 1">
                <span style="background-color: #67c23a"></span>
{{ $t("module.credit.title53") }}
              </div>
              <div class="participationStatus" v-if="scope.row.typeId === 2">
                <span style="background-color: #f56c6c"></span>
                {{ $t("module.credit.title54") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            :label="$t('module.credit.title63')"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="getCredits(1)"
            @current-change="getCredits"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import { getCredits } from "@/api/user";
export default {
  filters: {
    dateFrom(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      value: null,
      menuTop: 86,
      options: [
        {
          value: 1,
          label: this.$t("module.credit.title64"),
        },
        {
          value: 2,
          label: this.$t("module.credit.title65"),
        },
        {
          value: 3,
          label: this.$t("module.credit.title66"),
        },
      ],
      options2: [
        {
          value: 1,
          label: this.$t("module.credit.title67"),
        },
        {
          value: 2,
          label: this.$t("module.credit.title68"),
        },
        {
          value: 3,
          label: this.$t("module.credit.title66"),
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      flag: false,
      page2: 1,
      size2: 10,
      tableData2: [],
    };
  },
  components: { Navigation },
  methods: {
    goback() {
      this.$router.push("/module/creditValue");
    },
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },
    getCredits(type) {
      if (type) {
        this.page = type;
      }
      getCredits({
        page: this.page,
        size: this.size,
      }).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.list;
          this.total = res.data.dataCount;
        }
      });
    },

    getCredits2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      getCredits({
        page: this.page2,
        size: this.size2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },

    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.getCredits2();
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.listenScroll);
    this.getCredits();
    this.getCredits2();
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
  }
}

//表格
.table-box {
  // margin-top: 16px;
  height: 960px;
  margin-bottom: 24px;
  background-color: #fff;
  .table-name {
    font-size: 16px;
    color: #474f66;
    padding: 20px 0 20px 20px;
    font-weight: bolder;
    display: flex;
    justify-content: space-between;
    .goback {
      color: #66b1ff;
      cursor: pointer;
      font-weight: normal;
    }
  }
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 25px;
  }
}
.participationStatus {
  color: #474f66;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    width: 7px;
    height: 7px;
    border-radius: 3.5px;
    margin-right: 10px;
  }
}
.Auditing {
  color: #8948ff;
}

// 筛选移动端
.screen-box2 {
  display: none;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .left {
    font-size: 16px;
    color: #232323;
  }
  .el-select {
    width: 100px;
  }
}

//列表移动端
.list-box {
  display: none;
  max-height: 500px;
  overflow: auto;
  margin-top: 15px;
  margin-bottom: 25px;
  .list-item {
    width: 100%;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 10px;
    padding: 17px 0 17px 0;
    .line-box {
      padding: 0 15px 0 10px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #232323;
      margin-bottom: 12px;
      .title {
        font-size: 14px;
        color: #232323;
      }
      .color1 {
        font-size: 14px;
        color: #666666;
      }
      .content {
        flex-shrink: 0;
        margin-left: 10px;
      }
      .color2 {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #474f66;
        span {
          width: 7px;
          height: 7px;
          background: #1f61ff;
          border-radius: 3.5px;
          margin-right: 10px;
        }
      }
      .color3 {
        color: #232323;
        font-size: 16px;
        font-weight: bolder;
      }
    }
    .line-box:last-child {
      margin-bottom: 0;
    }
  }
  .flag {
    text-align: center;
    color: #999;
    font-size: 14px;
  }
}
</style>
<style scoped>
.table-box >>> .el-table__header .el-table__cell {
  background-color: #fafbfc;
  color: #474f66;
  font-size: 14px;
  font-weight: bolder;
  text-align: center;
}
.table-box >>> .el-table__body .el-table__cell {
  text-align: center;
  color: #474f66;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .sign-box {
        flex-direction: column;
        .sign {
          width: 100%;
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    .screen-box {
      display: none;
    }
    .table-box {
      display: none;
    }
    //筛选移动端
    .screen-box2 {
      display: flex;
    }
    .list-box {
      display: block;
    }
  }
}
</style>